import { useEffect } from 'react';
import { useServices } from '@/model';
import { forgetPositions } from './readingPositions';

export function ReadingPositionRuntime() {
  const services = useServices();
  useEffect(() => services.session.onRetire(event => forgetPositions(event.accountId)), [services]);
  return null;
}
